"use strict";

const { Routes } = require("@palmabit/sacajawea");
const routes = (module.exports = Routes({
  locale: process.env.DEFAULT_LANG,
  forceLocale: true,
}));

/*
API: routes.add(name, lang, pattern = /name, page = name)

Arguments:
 - name: Route name
 - pattern: Route pattern (like express, see path-to-regexp)
 - page: Page inside ./pages to be rendered
*/
routes
  .add("login", "it", "/login", "login")
  .add("login", "en", "/login", "login")
  .add("dashboard", "it", "/dashboard", "dashboard")
  .add("dashboard", "en", "/dashboard", "dashboard")
  .add("chat", "it", "/chat", "chat")
  .add("chat", "en", "/chat", "chat")
  .add("list-messages", "it", "/lista-messaggi", "list-messages")
  .add("list-messages", "en", "/list-messages", "list-messages")
  .add("settings", "it", "/impostazioni", "settings")
  .add("settings", "en", "/settings", "settings")
  .add("billing", "it", "/abbonamento", "billing")
  .add("billing", "en", "/subscription", "billing")
  .add("forgot", "it", "/password-dimenticata", "forgot-password")
  .add("forgot", "en", "/forgot-password", "forgot-password")
  .add("auth-action", "en", "/auth/action", "auth-action")
  .add(
    "inactive-subscription",
    "it",
    "/inactive-subscription",
    "inactive-subscription"
  )
  .add(
    "inactive-subscription",
    "en",
    "/inactive-subscription",
    "inactive-subscription"
  )
  .add("thank-you", "it", "/thank-you", "thank-you")
  .add("thank-you", "en", "/thank-you", "thank-you");



// WEBPACK FOOTER //
// routes.js